import React from 'react';
import { getErrorIssues, getWarningIssues } from '../../../../../../utils/validationSummary';

export default class BaseFeature extends React.Component {

    getClassName(properties) {
        return `card-feature-component ${getErrorIssues(this.props.issues, properties).length > 0 ? 'danger' : getWarningIssues(this.props.issues, properties).length > 0 ? 'warning' : ''}`;
    }

    getProperty(property) {
        return this.props.properties !== undefined && this.props.properties !== null 
                    ? this.props.properties.find(prop => prop.name === property) 
                    : null;
    }

    getColor(x, y) {
        x =+x;
        y =+y;

        let yDif = 0.1858 - y; 
        if (yDif === 0.0) {
            yDif = 0.0000001;
        }
        return Math.round(449 * Math.pow(((x - 0.332) / yDif), 3) + 3525 * Math.pow(((x - 0.332) / yDif), 2) + 6823.3 * ((x - 0.332) / yDif) + 5520.33); 
    }
}